import React from 'react';
import { Avatar, AvatarFallback } from './ui/avatar';
import { getCharacterInitials } from '../utils/user-initials';
import { cn } from '../lib/utils';

type CharacterAvatarProps = {
  name?: string | null;
  className?: string;
};

export const CharacterAvatar: React.FC<CharacterAvatarProps> = ({ name, className }) => {
  return (
    <Avatar className={cn('h-8 w-8', className)}>
      <AvatarFallback className="bg-muted text-muted-foreground">
        {getCharacterInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
};
